import { Star } from "lucide-react";
import { useTestimonials } from "@/hooks/use-homepage";
import { useLanguage } from "@/context/LanguageContext";
import { format } from "date-fns";

const TestimonialsSection = () => {
  const { data: testimonials = [] } = useTestimonials();
  const { t } = useLanguage();

  if (testimonials.length === 0) return null;

  return (
    <section className="bg-muted py-12 md:py-16">
      <div className="container mx-auto px-4">
        <h2 className="font-display text-2xl md:text-3xl font-bold mb-8 text-center">{t("home.testimonials")}</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {testimonials.map((item) => (
            <div key={item.id} className="bg-card rounded-xl border border-border p-6 shadow-sm">
              <div className="flex gap-0.5 mb-3">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={16} className={i < (item.rating ?? 5) ? "text-accent fill-accent" : "text-border"} />
                ))}
              </div>
              <p className="text-sm text-foreground/80 mb-4 italic">"{item.content}"</p>
              <div className="flex items-center justify-between">
                <span className="font-display font-semibold text-sm">{item.author_name}</span>
                <span className="text-xs text-muted-foreground">{format(new Date(item.created_at), "dd.MM.yyyy")}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
